import {
  DREAM_HOME,
  RENTAL_PROPERTY,
  RENT_BUY,
  SELL_POCKET
} from 'src/constants/gems'
import Gems from 'src/Components/Gem/gems'

const gemNames = [DREAM_HOME, RENTAL_PROPERTY, RENT_BUY, SELL_POCKET]

export default gemNames.map(name => Gems[name])
